import { render, staticRenderFns } from "./Recommendation.Survey.vue?vue&type=template&id=402c2aa2&scoped=true&"
import script from "./Recommendation.Survey.vue?vue&type=script&lang=js&"
export * from "./Recommendation.Survey.vue?vue&type=script&lang=js&"
import style0 from "./Recommendation.Survey.vue?vue&type=style&index=0&id=402c2aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402c2aa2",
  null
  
)

export default component.exports